import * as React from "react";
import {
  Provider as PaperProvider,
  Text,
  DefaultTheme,
} from "react-native-paper";
import { blackColor } from "../colors";
import { StyleSheet, SafeAreaView } from "react-native";
import PageContainer from "../PageContainer";
import routes from "../../routing/routes";
import { connect } from "react-redux";

const Blog = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const [expanded, setExpanded] = React.useState({});

  React.useEffect(() => {
    props.callToData();
  }, []);

  const handlePress = (i, value) => {
    const newExpanded = {
      ...expanded,
      [i]: value,
    };
    setExpanded(newExpanded);
  };
  return (
    <PageContainer
      {...props}
      isBackIcon={true}
      noBackground={true}
      isSettingsIconSelected={false}
      backRoute={props.user ? routes.Home : routes.RegistrationForm}
      isSettingsIcon={false}
    >
      <SafeAreaView styles={{ flex: 1 }}>
        <Text style={styles.text}>
          {props.pageData && props.pageData.title}
        </Text>
        {props.pageData &&
          props.pageData.content.map((paragraf, id) => {
            const isNested = typeof paragraf === "object";
            return isNested ? (
              <React.Fragment key={`blog-${id}`}>
                <Text style={styles.title}>{paragraf.paragrafTitle}</Text>
                {paragraf.paragrafContent.map((subParagraf, j) => (
                  <Text  key={`blog-text-${id}-${j}`}style={styles.subtitle}>{subParagraf}</Text>
                ))}
              </React.Fragment>
            ) : (
              <React.Fragment key={`blog-${id}`}>
                <Text style={styles.title}>{titleParagraf}</Text>
                <Text style={styles.subtitle}>{paragraf}</Text>
              </React.Fragment>
            );
          })}
      </SafeAreaView>
    </PageContainer>
  );
};

const mapStateToProps = (state) => {
  const user = state.user;
  return { user };
};

export default connect(mapStateToProps)(Blog);

const styles = StyleSheet.create({
  text: {
    paddingTop: 30,
    fontSize: 20,
    letterSpacing: 1,
    color: blackColor,
    padding: 8,
    textAlign: "left",
  },
  title: {
    padding: 8,
    textAlign: "left",
    fontWeight: "bold",
  },
  subtitle: {
    padding: 8,
    textAlign: "left",
  },
});
